// Ensure webpack processes the main scss file.
import './radio-interviews.scss';

document.addEventListener( 'DOMContentLoaded', function () {

	const orderSelect = document.querySelector( '.interview-order-select' );

	if ( ! orderSelect ) return;

	orderSelect.addEventListener( 'change', function () {
		const url    = new URL( window.location.href );
		const order  = this.value;

		url.searchParams.set( 'interview_order', order );

		// Reset to page 1 when changing sort order.
		url.searchParams.delete( 'interview_page' );

		window.location.href = url.toString();
	} );

} );
